import "./licencelist.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import LicenceDataTable from "../../components/datatable/LicenceDataTable"
import {useState, useEffect} from "react";
import { useParams } from "react-router-dom";

const LicenceList = (props) => {
  const {serverURL, queryData} = useParams();
   console.log("server:", serverURL)
   console.log("search:", queryData)
   
  return (
    <div className="home">
      <Sidebar/>
      <div className="homeContainer">
        <Navbar/>
        <LicenceDataTable serverURL='http://localhost:5021' queryData={queryData} />
      </div>
    </div>
  )
}

export default LicenceList